import { useTranslation } from "react-i18next";
import { Checkbox } from "@/components/ui/checkbox";
import { usePeopleSearch } from "@/contexts/PeopleSearchContext";

// Same hardcoded status list as Candidates.tsx / StatusFilter.tsx
const STATUS_VALUES = ["new", "looking", "open", "unavailable", "hired"];

export function StatusPanel() {
	const { t } = useTranslation();
	const { draft, updateDraft } = usePeopleSearch();

	const toggleStatus = (status: string, checked: boolean) => {
		const values = checked
			? [...draft.status.values, status]
			: draft.status.values.filter(v => v !== status);
		updateDraft('status', { values });
	};

	return (
		<div className="space-y-4">
			<p className="text-sm text-muted-foreground">
				{t("peopleSearch.status.hint", "Candidates with any of these statuses")}
			</p>
			<div className="space-y-1">
				{STATUS_VALUES.map(status => (
					<label key={status} className="flex items-center gap-2 px-1 py-1.5 rounded-sm hover:bg-muted cursor-pointer">
						<Checkbox
							checked={draft.status.values.includes(status)}
							onCheckedChange={checked => toggleStatus(status, !!checked)}
						/>
						<span className="text-sm">{t(`candidates.status.${status}`, status)}</span>
					</label>
				))}
			</div>
		</div>
	);
}
